// hooks/useCaptionUpload.js
import UseToast from '../Component/UseToast';
import axios from 'axios';

export const useCaptionUpload = () => {
    const { showMsgSuccessToast, showErrorToast } = UseToast();

    const handleCaptionUpload = async (captionFile, convertSrtToVtt, setUploadedUrls, videoKey, userId) => {
        console.log('captionfile', captionFile);

   

        try {
            let fileToUpload = captionFile;
            
            // Convert SRT to VTT if needed
            if (captionFile.name.endsWith('.srt')) {
                const srtText = await captionFile.text();
                const vttText = convertSrtToVtt(srtText);
                
                const vttFileName = captionFile.name.replace(/\.srt$/i, '.vtt');
                const vttBlob = new Blob([vttText], { type: 'text/vtt' });
                
                fileToUpload = new File([vttBlob], vttFileName, {
                    type: 'text/vtt',
                    lastModified: Date.now(),
                });
            }

            // Step 1: Get Pre-signed URL for caption file
            const response = await axios.get('/generate-signed-url', {
                params: {
                    fileName: fileToUpload.name,
                    fileType: fileToUpload.type || 'text/vtt',
                },
            });

            const { url } = response.data;

            // Step 2: Upload the caption file to S3
            await axios.put(url, fileToUpload, {
                headers: {
                    'Content-Type': fileToUpload.type || 'text/vtt',
                },
            });

            // Step 3: Save the caption file URL
            const fileUrl = url.split('?')[0];

            // Update the state with caption file
            setUploadedUrls(prev => ({
                ...prev,
                [videoKey]: {
                    ...prev[videoKey],
                    captionFile: fileUrl,
                },
            }));

            showMsgSuccessToast('Caption file uploaded successfully!');
        } catch (error) {
            console.error('Caption upload failed:', error);
            if (error.message.includes('Invalid SRT content')) {
                showErrorToast('Invalid SRT file format. Please check the file and try again.');
            } else if (error.message.includes('Failed to convert')) {
                showErrorToast('Failed to convert SRT file. Make sure it\'s a valid SRT format.');
            } else {
                showErrorToast('Failed to upload caption file!');
            }
            throw error;
        }
    };

    return { handleCaptionUpload };
};